/**
 *  Created by piotr@revisual.io on 18/08/2025
 */

import { useState, useRef, useCallback } from "react";

export function useSwipe(onSwipe, threshold = 50) {
  const [swiping, setSwiping] = useState(false);
  const startX = useRef(0);
  const endX = useRef(0);

  const onStart = useCallback((clientX) => {
    startX.current = clientX;
    endX.current = clientX;
    setSwiping(true);
  }, []);

  const onMove = useCallback(
    (clientX) => {
      if (!swiping) return;
      endX.current = clientX;
    },
    [swiping]
  );

  const onEnd = useCallback(() => {
    if (!swiping) return;

    const delta = endX.current - startX.current;
    let dir = null;

    if (Math.abs(delta) > threshold) {
      dir = delta > 0 ? "right" : "left";
      if (onSwipe) onSwipe(dir);
    }

    setSwiping(false);
  }, [swiping, onSwipe, threshold]);

  const bind = {
    onMouseDown: (e) => onStart(e.clientX),
    onMouseMove: (e) => onMove(e.clientX),
    onMouseUp: onEnd,
    onMouseLeave: onEnd,
    onTouchStart: (e) => onStart(e.touches[0].clientX),
    onTouchMove: (e) => onMove(e.touches[0].clientX),
    onTouchEnd: onEnd,
  };

  return { swiping, bind };
}

export default useSwipe;
